import {AiFillApple,AiFillAudio,AiFillCheckCircle,AiFillApi,AiFillPushpin,AiFillRedditCircle,AiFillSmile,AiFillUnlock}from 'react-icons/ai'

export const AminitiesData=[
    {
        id:1,
        icon:AiFillUnlock,
        name:'Parking Space'
    },
    {
        id:2,
        icon:AiFillApple,
        name:'Smart Homes'
    },
    
    {
        id:3,
        icon:AiFillAudio,
        name:'Kid’s Playland'
    },
    
    {
        id:4,
        icon:AiFillCheckCircle,
        name:'Parking Space'
    },
    
    {
        id:5,
        icon:AiFillSmile,
        name:'Swimming Pool'
    },
    
    {
        id:6,
        icon:AiFillApi,
        name:'Private Security'
    },
    {
        id:7,
        icon:AiFillPushpin,
        name:'Medical Center'
    },
    
    {
        id:8,
        icon:AiFillRedditCircle,
        name:'Library Area'
    },
    
]